type Options = { excludeKeys?: string[]; allowEmptyValues?: boolean }

export const withoutNullKeyValues = (
  obj: { [key: string]: any },
  { excludeKeys, allowEmptyValues = true }: Options,
) => {
  const clone = { ...obj }
  for (const propName in clone) {
    if (excludeKeys && excludeKeys.includes(propName)) {
      continue
    }
    if (clone[propName] === null || clone[propName] === undefined) {
      delete clone[propName]
    }
    if (!allowEmptyValues && clone[propName] === '') {
      delete clone[propName]
    }
  }
  return clone
}

export const equals = (a: any, b: any): any => {
  if (a === b) return true
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime()
  if (!a || !b || (typeof a !== 'object' && typeof b !== 'object'))
    return a === b
  if (a.prototype !== b.prototype) return false
  const keys = Object.keys(a)
  if (keys.length !== Object.keys(b).length) return false
  return keys.every(k => equals(a[k], b[k]))
}

export const buildQueryParams = (params: { [key: string]: any }) => {
  return Object.keys(params)
    .map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    })
    .join('&')
}

// { bold: true, italic: false, underline: true} => ['bold', 'underline']
export const objectOfBooleansToStringArray = (obj: {
  [key: string]: boolean
}) => {
  return Object.keys(obj).filter(key => obj[key])
}
